module.exports = __webpack_public_path__ + "static/media/matlab.3b79e65d.svg";